export interface appType {
  key: string;
  name: string;
  icon: string; // Icon identifier
  color: string; // Hex color for background
  description: string;
}

const appTypesList: appType[] = [
  {
    key: 'telegramMiniApp',
    name: 'Telegram Mini App',
    icon: 'ic:baseline-telegram',
    color: '#3F9EF6',
    description:
      'This app allows you to embed our script to display, process, and manage offers from partners, as well as handle user reward claims.'
  }
];

export const getAppTypeByKey = (key: string): appType => {
  return appTypesList.find((source) => source.key === key) || appTypesList[0];
};

export default appTypesList;
